import { defineComponent as _defineComponent } from 'vue'
import {ref, watch} from "vue";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


export default /*#__PURE__*/_defineComponent({
  __name: 'DatePickerInput',
  props: {
    modelValue: {
        type: String
    },
    label: {
        type: String
    },
    tooltip: {
        type: String
    },
    required: {
        type: Boolean
    },
    typeable: {
        type: Boolean
    },
    placeholder: {
        type: String
    },
    id: {
        type: String
    },
    locale: {
        type: String
    },
    max: {
        type: String
    },
    disabledDates: {
        type: Object
    }
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props;






const date = ref(props.modelValue)
const show = ref(false)

// @ts-ignore
watch(() => props.modelValue, (first, second) => {
    if (first) {
        date.value = props.modelValue
    }
    if (second) {
        date.value = props.modelValue
    }
})

function emitEvent(event: any) {
    show.value = false
    emit('update:modelValue', event)
}


return { __sfc: true,props, emit, date, show, emitEvent, DatePicker }
}

})